import { imagePlanner as Image } from './imagePlanner'
import { fixDataItem as GlobalImageQuality } from './globalImageQualityPlanner'
import { Planner } from './typeResolverUtils'

export const dataPlanners = {
	Image,
	GlobalImageQuality,
} as Record<string, Planner<any, any, any>>
